import { gofor } from '@fiverr-private/futile/lib/gofor';
import tracker from './tracker';

const config = require('../../../../configuration/config');

const routesQueue = {};
const cache = {

    get(route){
        return routesQueue[route] || [];
    },
    set(route, val){
        routesQueue[route] = [...this.get(route), val];
    },
    removeEntry(route) {

        const current = [...this.get(route)];
        current.shift();

        routesQueue[route] = current;
    }
};

class RequestService {

    initialize(context) {

        this.context = context;
    }

    post(route, payload){

        cache.set(route, payload);

        return doGofor(route, payload, this.context, 'POST').then((result) => {

            const currentQueue = cache.get(route);
            result.accepted = currentQueue.length === 1;

            cache.removeEntry(route);
            return result;
        });
    }
}

const doGofor = (route, payload, context, method) => gofor(`${config.api_prefix}/${route}`, {
    method,
    body: JSON.stringify({
        ...context,
        ...payload
    })
}).then((response) => {

    !response.ok && handleError(route, response);

    return response.json();
});

const handleError = (url, response) => {

    const error = {
        message: `Failed on Search perseus Request service | url: ${url} ,status: ${response.status}, text: ${response.statusText}`
    };

    tracker.log(error);
    throw error;
};

export default new RequestService();
